<template>
  <div style="background: #f9f9f9">
    <!-- 顶部搜索 -->
    <div class="printBanner">
      <div style="height: 170px">
        <div class="container">
          <el-row :gutter="30" style="padding-top: 50px">
            <el-col :span="12" :offset="6" class="bannerSearch">
              <el-input
                size="large"
                placeholder="请输入内容"
                v-model="form.keyword"
                class=""
                @keyup.native.enter="search"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  type="primary"
                  @click="search"
                ></el-button>
              </el-input>
              <ul class="flex" style="font-size: 12px; color: #fff">
                <li style="margin: 15px; margin-left: 0px; cursor: pointer" @click="searchByKeyword(items)" v-for="(items, index) in keywords">{{ items }}</li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 标题 -->
    <div class="desTitle flex">
      <!--<p>需求列表</p>-->
      <span>当前位置：</span>
      <!-- <span>设计市场 > 需求列表</span> -->
	<el-breadcrumb separator=">">
		<el-breadcrumb-item :to="{ path: '/design' }">设计市场</el-breadcrumb-item>
		<el-breadcrumb-item >全部需求</el-breadcrumb-item>
	  </el-breadcrumb>
    </div>
    <!-- 选择类型 -->
    <div class="desClass">
      <div class="desClass_width flex">
        <p class="print_title" style="padding: 3px 10px">分类：</p>
        <div>
          <div class="print_screen_boxP">
            <p
              v-for="(items, index) in screenList"
              :key="index"
              style="cursor: pointer;"
              @click="getPrintScreen(index)"
              :class="printScreenIndex == index ? 'screen_text' : ''"
            >
              {{ items.name }}
            </p>
          </div>
          <div
            class="flex"
            style="
              padding: 15px 15px 5px;
              background: rgb(241, 245, 254);
              margin-top: 10px;
              width: 1000px;
            "
            v-show="classShow"
          >
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              style="margin-right: 20px"
              >全选</el-checkbox
            >
            <div style="margin: 15px 0"></div>
            <el-checkbox-group
              v-model="checkedCities"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox
                v-for="(city, index) in screenList[printScreenIndex].screenTwo"
                :label="city"
                :key="index"
                >{{ city.names }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <!-- 筛选 -->
      <div class="desChoose flex">
        <!-- <el-radio-group v-model="screenRadioValue" class="comprehensiveRanking">
          <el-radio-button label="预算" class="radioButtonWidth1"
            >预算
            <i
              v-show="screenRadioValue === '预算'"
              class="el-icon-arrow-down"
            ></i
          ></el-radio-button>
          <el-radio-button label="发布时间" class="radioButtonWidth2"
            >发布时间
            <i
              v-show="screenRadioValue === '发布时间'"
              class="el-icon-arrow-down"
            ></i
          ></el-radio-button>
          <el-radio-button label="截止时间" class="radioButtonWidth2"
            >截止时间
            <i
              v-show="screenRadioValue === '截止时间'"
              class="el-icon-arrow-down"
            ></i
          ></el-radio-button>
        </el-radio-group> -->
        <div class="sortClass">
          <!-- <div class="typeName">排序：</div> -->
          <ul>
            <li
              v-for="(item, index) in sortList"
              :class="activeSortIndex === index ? 'active' : ''"
              @click="search(index)"
              :key="index"
            >
              {{ item.name }}
              <i
                class="el-icon-bottom"
                v-if="index == 0 && activeSortIndex1 == 0"
              ></i>
              <i
                class="el-icon-top"
                v-if="index == 0 && activeSortIndex1 == 1"
              ></i>
              <i
                class="el-icon-bottom"
                v-if="index == 1 && activeSortIndex2 == 0"
              ></i>
              <i
                class="el-icon-top"
                v-if="index == 1 && activeSortIndex2 == 1"
              ></i>
              <i
                class="el-icon-bottom"
                v-if="index == 2 && activeSortIndex3 == 0"
              ></i>
              <i
                class="el-icon-top"
                v-if="index == 2 && activeSortIndex3 == 1"
              ></i>
            </li>
          </ul>
        </div>
        <!-- <div class="desChoose_time budgetType">
                    <p>预算类型</p>
                    <el-select v-model="moneyClass" placeholder="全部" size="small" style="width: 120px;">
                        <el-option
                            v-for="item in moneyoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div> -->
        <div class="desChoose_time">
          <el-checkbox v-model="showCheck" @change="search(-1)"></el-checkbox>
          <p class="desChooseP_old">显示未过期需求</p>
        </div>
      </div>
    </div>

    <!-- 需求列表 -->
    <div class="designList">
       <div v-if="showNoService" style="text-align:center;margin-bottom:20px" >
          <img src="../../assets/暂无搜索内容.jpg" alt="" style="width:200px">
        </div>
      <section v-if="demandList.length!=0">
        <!-- <h2 class="printTitle">找需求</h2>/ -->
        <el-row :gutter="30">
          <el-col :span="6" v-for="(items, index) in demandList" :key="index">
            <el-card class="box-card" shadow="hover">
              <div
                :class="
                  items.state === '已过期'
                    ? 'pastTag listTag'
                    : items.state === '已验收'
                    ? 'finishTag listTag'
                    : 'listTag'
                "
              >
                {{ items.state == '审核通过' ? '询价中' : items.state }}
              </div>
              <h4 class="rqTitle">{{ items.title }}</h4>
              <div class="rqPrice">
                <span class="tagBlue">预算</span>
                <span><i>¥</i> {{ items.money }}</span>
              </div>
              <dl class="rqDetail">
                <dt v-if="items.describe != null">模型尺寸：</dt>
                <dd v-if="items.describe != null">
                  {{ items.describe }}
                </dd>
                <dt v-if="items.describe == null">需求类型：</dt>
                <!-- <dd v-if="items.describe == null">设计需求</dd> -->
                 <dd v-if="items.describe == null&&items.type=='DESIGN'">平面设计-{{items.name}}</dd>
                 <dd v-if="items.describe == null&&items.type=='MODEL'">三维设计-{{items.name}}</dd>
                <dt>需求描述：</dt>
                <dd
                  style="
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    min-height: 72px;
                  "
                >
                  {{ items.size }}
                </dd>
                <dt>期望交期：</dt>
                <dd>{{ items.date }}</dd>
              </dl>
              <!-- <br style="float: none" /> -->
              <div class="rqFooter">
                <span @click="getDetailsMess(items.uuid)">查看详情</span>
                <span @click="startChat(items.creator)">立即联系</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: right; padding: 50px 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current"
            :page-sizes="[20, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </section>
    </div>

    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
  </div>
</template>

<script>
import {getDictionaryItem, demandListByPage, getRongCloudUser} from "../../utils/interface";
import { mapState, mapMutations } from "vuex";
import chatDialog from "../chat/chatDialog";
export default {
  //   需求列表
  name: "designList",
  metaInfo: {
    title: '找需求 -设计市场- 提供企业、个人用户、设计师的供需对接服务-增材云', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: 'logo设计 |  模型设计 | 建筑模型设计 | 人像设计需求 | 文创模型 | 发布需求 '
    },
      {                 // set meta
        name: 'description',
        content: '增材云找需求服务，为公司及个人提供专业的建模需求、设计需求等服务资源，用户可以发布需求进行方案定制、为企业提供一站式供需对接服务。'
      }
    ],
  },
  components: {
    chatDialog
  },
  data() {
    return {
      showNoService:false,
      keywords:[],
      form: {keyword:'',},
      current: 1,
      total: 0,
      pageSize: 20,
      // 作品选择
      checkAll: false,
      checkedCities: [],
      isIndeterminate: true,
      checkedCountsleng: [],
      design: [],
      demandList: [],
      screenList: [
        {
          name: "全部",
          screenTwo: [],
        },
        {
          name: "",
          screenTwo: [],
        },
        {
          name: "",
          screenTwo: [],
        },
      ],
      printScreenIndex: "0",
      classShow: false,
      timeValue: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      moneyClass: "",
      moneyoptions: [
        {
          value: "选项1",
          label: "全部",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      showCheck: false,
      screenRadioValue: "综合",

      sortList: [
        {
          name: "预算",
        },
        {
          name: "发布时间",
        },
        {
          name: "截止时间",
        },
      ],
      activeSortIndex: "",
      activeSortIndex1: 0,
      activeSortIndex2: 0,
      activeSortIndex3: 0,
    };
  },
  computed: {
    ...mapState({
      isLogin: "isLogin",
    }),
  },
  mounted() {},
  created() {
    this.getDictionaryItem();
    this.search();
  },
  methods: {
    ...mapMutations(["isLoginVuex"]),
    handleCheckAllChange(val) {
      this.checkedCities = val
        ? this.screenList[this.printScreenIndex].screenTwo
        : [];
      this.isIndeterminate = false;
      console.log(this.checkedCities);
      if (this.checkedCities.length > 0) {
        let cates = [];
        this.checkedCities.forEach((item, index) => {
          cates.push(item.id);
        });
        let categories = cates.join(",");
        this.form.cates = categories;
        this.search();
      }
    },
    handleCheckedCitiesChange(value) {
      this.checkedCountsleng = value;
      let checkedCount = this.checkedCountsleng.length;
      this.checkAll =
        checkedCount ===
        this.screenList[this.printScreenIndex].screenTwo.length;
      this.isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.screenList[this.printScreenIndex].screenTwo.length;
      console.log("----------------------" + JSON.stringify(value));
      if (value.length > 0) {
        let cates = [];
        value.forEach((item, index) => {
          cates.push(item.id);
        });
        let categories = cates.join(",");
        this.form.cates = categories;
        this.search();
      }
    },
    // 获取字典值
    getDictionaryItem() {
      let resource = [];
      getDictionaryItem({ groupCode: "model" }).then((res) => {
        let re = [];
        if(res != null && res.length > 0) {
          this.screenList[1].name = res[0].groupName;
          res.forEach((item, index) => {
            re.push({names: item.name, id: item.code, groupId: item.groupUuid});
            resource.push({
              names: item.name,
              id: item.code,
              groupId: item.groupUuid,
            });
          });
          this.screenList[1].screenTwo = re;
        }
        getDictionaryItem({ groupCode: "design" }).then((res) => {
          let re = [];
          if(res != null && res.length > 0) {
            this.screenList[2].name = res[0].groupName;
            res.forEach((item, index) => {
              re.push({names: item.name, id: item.code, groupId: item.groupUuid});
              resource.push({
                names: item.name,
                id: item.code,
                groupId: item.groupUuid,
              });
            });
            this.screenList[2].screenTwo = re;
            this.screenList[0].screenTwo = resource;
            console.log(this.screenList);
          }
        });
      });
      getDictionaryItem({groupCode: 'design_keyword'}).then((res)=>{
        // let re = [];
        if(res != null && res.length > 0){
          res.forEach((item, index) => {
            this.keywords.push(item.name);
          });
        }
      });
    },
    searchByKeyword(keyword){
      this.form.keyword = keyword;
      this.search();
    },
    getDetailsMess(uuid) {
      let routeData = this.$router.resolve({
        name: "designDetails",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    getPrintScreen(i) {
      if (this.printScreenIndex == i) {
        this.classShow = !this.classShow;
      } else {
        this.classShow = true;
      }
      this.printScreenIndex = i;
      this.checkAll = true;
      this.handleCheckAllChange(true);
    },
    search(index) {
      this.form.status = "";
      if (this.showCheck) {
        this.form.status = "PROCESS";
      // } else {
      //   this.form.status = "PASS";
      }else{
        if (index == 0 && this.activeSortIndex1 == 1) {
          this.form.sort = "HIGH_PRE_AMOUNT";
          this.form.order = "DESC";
          this.activeSortIndex = 0;
          this.activeSortIndex1 = 0;
        } else if (index == 0 && this.activeSortIndex1 == 0) {
          this.form.sort = "HIGH_PRE_AMOUNT";
          this.form.order = "ASC";
          this.activeSortIndex = 0;
          this.activeSortIndex1 = 1;
        } else if (index == 1 && this.activeSortIndex2 == 1) {
          this.form.sort = "PUBLISH_TIME";
          this.form.order = "DESC";
          this.activeSortIndex = 1;
          this.activeSortIndex2 = 0;
        } else if (index == 1 && this.activeSortIndex2 == 0) {
          this.form.sort = "PUBLISH_TIME";
          this.form.order = "ASC";
          this.activeSortIndex = 1;
          this.activeSortIndex2 = 1;
        } else if (index == 2 && this.activeSortIndex3 == 1) {
          this.form.sort = "DEAD_LINE";
          this.form.order = "DESC";
          this.activeSortIndex = 2;
          this.activeSortIndex3 = 0;
        } else if (index == 2 && this.activeSortIndex3 == 0) {
          this.form.sort = "DEAD_LINE";
          this.form.order = "ASC";
          this.activeSortIndex = 2;
          this.activeSortIndex3 = 1;
        }
      }

      if(this.isLogin){
        this.form.isLogin = 1
      }else{
        this.form.isLogin = 0
      }
      this.form.current = this.current;
      this.form.pageSize = this.pageSize;
      demandListByPage(this.form).then((res) => {
        this.demandList = [];
        if (res != null && res.list != null && res.list.length > 0) {
          this.showNoService=false;
          this.total = res.total;
          res.list.forEach((item, index) => {
            let demand = {};
            demand.uuid = item.uuid;
            demand.title = item.demandName;
            demand.creator = item.creator;
            //需求类型中展示修改
            demand.type=item.demandType;
            demand.name=item.demandClassName;
            demand.money = item.lowPreAmount + "-" + item.highPreAmount;
            if (item.demandDes != null && item.demandDes != undefined) {
              demand.size = item.demandDes;
            }
            if (item.demandType == "MODEL") {
              demand.describe =
                item.specificationsStart + "~" + item.specificationsEnd + "cm";
            }
            demand.date = item.expectedDeliveryTime;
            // let isTimeOut =
            //   new Date().getTime() > new Date(item.deadline).getTime();
            // if (isTimeOut) {
            //   demand.state = "已过期";
            // } else if (item.status == "PASS" && item.winner == null) {
            //   demand.state = "报价中";
            // } else if (
            //   item.winner != "" &&
            //   item.winner != null &&
            //   item.winner != undefined
            // ) {
            //   demand.state = "已结束";
            // }
            demand.state = item.statusCn;
            this.demandList.push(demand);
          });
        } else {
          this.showNoService=true;
          this.total = 0;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.current = val;
	  window.scrollTo(0,0);
      this.search();
    },
    startChat(targetUserId) {
      if (this.isLogin) {
        let user = this.$store.state.isUsermessage;
        getRongCloudUser(targetUserId).then(res=> {
          this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
        });
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    }
  },
};
</script>

<style scoped lang="less">
.printBanner {
  background: url("../../assets/image/fulist.png");
}

.container {
  width: 1200px;
  margin: 0 auto;
  .bannerSearch {
    /deep/ .el-input__inner {
      height: 50px;
      line-height: 50px;
    }

    /deep/ .el-input-group__append {
      background-color: #157efb;
      color: #fff !important;
      font-size: 18px;
      border-color: transparent;
    }
  }
}

.desTitle {
  width: 1200px;
  margin: 25px auto;
  align-items: center;

  p {
    font-size: 18px;
    margin-right: 5px;
  }

  span {
    color: #808080;
    font-size: 14px;
    // &:nth-of-type(1) {
    //   color: #c9c9c9;
    // }
  }
}
.sortClass {
  .typeName {
    padding: 5px 20px 5px 12px;
  }
  ul {
    display: flex;

    li {
      padding: 5px 12px;
      cursor: pointer;
      margin-right: 10px;
      background: #fff;
      color: #157efb;

      &.active {
        color: #fff;
        background: #157efb;
      }
    }
  }
}
.desClass {
  width: 1200px;
  margin: 25px auto 0;
  // background: #f9fbff;
  // padding: 20px 25px;
  box-sizing: border-box;
  font-size: 14px;
  box-sizing: border-box;

  .desClass_width {
    width: 1200px;
    background: #fff;
    padding: 20px 0;
    margin: 0 auto;
    box-sizing: border-box;

    p {
      margin-right: 0;
      padding: 3px 14px;
    }

    .print_title {
      flex-shrink: 0;
    }

    .print_screen_boxP {
      display: flex;
      flex-wrap: wrap;

      .screen_text {
        cursor: pointer;
        background: #157efb;
        border-radius: 5px;
        color: #fff;
        padding: 3px 14px;
        font-size: 14px;
      }
    }

    .materDetailsT {
      // background: #157efb;
      color: #157efb;
      border-radius: 5px;
      padding: 3px 15px;
      margin-bottom: 10px;
    }
  }
}

.desChoose {
  width: 1200px;
  margin: 0 auto;
  padding: 18px 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  color: #262626;
  .comprehensiveRanking {
    /deep/.el-radio-button {
      height: 35px;
    }
    /deep/.el-radio-button__inner {
      height: 35px;
      padding: 0 10px;
      font-size: 14px;
      line-height: 33px;
      border-color: #fff;
      &:hover {
        color: #157efb;
      }
    }
    /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: #f1f1f1;
      color: #000000;
      border-color: #f1f1f1;
      box-shadow: none;
    }
    .radioButtonWidth1 {
      /deep/.el-radio-button__inner {
        width: 70px;
        text-align: center;
      }
    }
    .radioButtonWidth2 {
      /deep/.el-radio-button__inner {
        width: 96px;
        text-align: center;
      }
    }
  }

  .el-dropdown-link {
    background: #157efb;
    border-radius: 5px;
    padding: 8px 15px;
    color: #fff;
    cursor: pointer;
  }
  .desChoose_time {
    display: flex;
    align-items: center;
    margin-left: 33px;
    /deep/.el-checkbox__inner {
      border-radius: 50%;
      width: 20px;
      height: 20px;
    }
    /deep/.el-checkbox__inner::after {
      top: 4px;
      left: 7px;
    }
    p {
      margin-right: 10px;
    }

    .desChooseP_old {
      margin-left: 5px;
      margin-right: 0;
      color: #777;
    }
  }
}

.designList {
  width: 1200px;
  margin: 0 auto;
    /deep/.el-col-6 {
    height: 324px;
  }

  .printTitle {
    font-size: 28px;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 60px;
    margin-bottom: 15px;

    span.more {
      font-size: 16px;
      float: right;
      margin-top: 10px;
    }

    .more i {
      color: #505050 !important;
    }
  }

  .box-card {
    border: 1px solid #e3e3e3;
    margin-bottom: 30px;
    position: relative;
    width: 100%;
  }

  .fMaster {
    cursor: pointer;
    display: flex;
    position: relative;

    /deep/ .el-avatar--96 {
      width: 80px;
      height: 80px;
    }
  }

  .fMasterInfo {
    flex: 1;
    margin-left: 10px;

    .fMasterInfoName {
      margin-bottom: 10px;
    }

    .fMasterInfoAddr {
      font-size: 12px;
      color: #808080;
    }

    .fMasterInfoAddr i {
      margin-right: 5px;
    }

    .fMasterAna {
      font-size: 12px;
      margin: 20px 0;
    }

    .fMasterAna span.numBlue {
      color: #157efb;
      margin-left: 5px;
    }

    .fMasterBtn {
      /deep/ .el-button {
        font-weight: normal;
      }

      /deep/ .el-button--default {
        color: #157efb;
        border: 1px solid #157efb;
      }
    }
  }

  .fMasterDesc {
    margin: 20px -20px 0;
    padding: 20px 20px 0;
    font-size: 14px;
    border-top: 1px solid #e3e3e3;
  }
  .listTag {
    position: absolute;
    right: 15px;
    top: 16px;
    font-size: 12px;
    color: #1ed76d;
    font-weight: bold;
    width: 50px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 6px;
    background: rgba(30, 215, 109, 0.13);
    &.finishTag {
      background: rgba(0, 0, 0, 0.13);
      color: #000;
    }
    &.pastTag {
      background: rgba(252, 98, 96, 0.13);
      color: #f66565;
    }
  }
  .rqTitle {
    font-size: 16px;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 10px;
    width: 180px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .rqPrice {
    font-size: 14px;
    color: #157efb;
    border: 1px solid #157efb;
    padding: 5px 20px 5px 70px;
    position: relative;
    width: fit-content;

    span.tagBlue {
      background-color: #157efb;
      color: #fff;
      font-size: 12px;
      width: 50px;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .rqDetail {
    margin-top: 20px;
    height: 138px;
    dt {
      float: left;
      width: 70px;
      color: #000;
      font-size: 13px;
      font-weight: 400;
      text-align: right;
      line-height: 24px !important;
    }

    dd {
      color: #808080;
      font-size: 13px;
      line-height: 24px !important;
      margin-left: 80px;
      margin-bottom: 8px;
    }
  }

  .rqFooter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f1f5fe;
    border: 1px solid #e3e3e3;
    margin: 0 -21px -21px;
    position: relative;

    span {
      display: inline-block;
      width: 50%;
      text-align: center;
      font-size: 13px;
      height: 50px;
      color: #157efb;
      line-height: 50px;
      cursor: pointer;
    }

    span a {
      color: #157efb;
    }

    span a:hover {
      color: rgba(21, 126, 251, 0.8);
    }

    :after {
      position: absolute;
      content: "";
      width: 1px;
      background-color: #e3e3e3;
      height: 34px;
      top: 8px;
      left: 50%;
    }
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  /deep/ .el-carousel__button {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/designList.vue